import { Store, ActionTree, ActionContext } from 'vuex'
import { State } from './state'
import {UserService} from "@/services/user.service";
import { AuthenticationError } from '@/services/responses/AuthenticationError';
import router from "@/router";
import {UserCredentials} from './types'
import {  Action, Getter, namespace } from 'vuex-class';
const SettingsModule = namespace('SettingsModule')

export async function login(store: ActionContext<State, any>, credentials: UserCredentials) {
    store.commit('loginRequest');

    try {
        const token = await UserService.login(credentials.email, credentials.password);
        store.commit('loginSuccess', token);
        store.dispatch('SettingsModule/getAllSettings', {}, {root: true});


        // Redirect the user to the page he first tried to visit or to the home view
        //router.push(router.history.current.query.redirect || '/');
        router.push('/');

        return true
    } catch (e) {
        if (e instanceof AuthenticationError) {
            store.commit('loginError', e)
        }

        return false
    }
}


export function logout(store: ActionContext<State, any>) {
    UserService.logout()
    store.commit('logoutSuccess')
    store.dispatch('SettingsModule/cleanSettings', {}, {root: true});
    router.push('/login')
}

export default <ActionTree<State, any>> {
    login, logout
}
